import { combineEpics } from 'redux-observable';
import { catchError } from 'rxjs/operators';

import {
  getWorkOrderDetailEpic,
  getWorkOrderHistoryByAddressIdEpic,
  getTechRouteEpic,
  getDigitalChannelsEpic,
  getWorkOrderByIdEpic,
  addCloseRequestEpic,
  startOrderCloseEpic,
  sendHitEpic,
  sendBalancingHitEpic,
  sendRefreshHitEpic,
  updateTagsEpic,
  outletUpdateEpic,
  sendUnpairPairEpic,
  updateCustomerEmailEpic,
  getWorkOrderHistoryByTechIdEpic,
  getAddressFromBillerEpic,
  outletUpdateAppianEpic,
  getHomeVerifyEpic,
  setHomeVerifyEpic,
  pinResetEpic,
  deliveryProofEpic,
  asurionPlusEnrollmentEpic,
  getNoAccessReasonListEpic,
  addEquipmentBySerialNumberEpic,
  transferWorkOrderEpic
} from './workOrderEpics';

import { setTechStatusEpic } from './statusEpics';
import { getUserChannelGrantEpic, getUserChannelGrantAppianEpic } from './messageEpics';
import { userInfoEpic, techInfoEpic } from './userEpics';
import { addMemoEpic } from './memoEpic';
import { generateSqcEpic } from './sqcEpics';
import { getTechInventoryEpic, searchForInventoryEpic, transferTechEquipmentEpic } from './techInventoryEpics';
import { addChargeEpic, updateChargeEpic, removeChargeEpic, unnecessaryTruckRollEpic } from './chargeEpic';
import { sendTransactionLogEpic } from './transactionLogEpic';
import { addEquipmentOptionEpic } from './equipmentOptionsEpic';
import { addJustAskEpic, updateJustAskEpic } from './justAskEpics';
import { getProvisioningStatusEpic } from './provisioningEpics';
import { getActiveServicesEpic } from './careAccountEpics';

export const epics = [
  getTechInventoryEpic,
  generateSqcEpic,
  getWorkOrderDetailEpic,
  getWorkOrderHistoryByAddressIdEpic,
  userInfoEpic,
  techInfoEpic,
  setTechStatusEpic,
  getTechRouteEpic,
  addMemoEpic,
  getWorkOrderHistoryByTechIdEpic,
  addChargeEpic,
  updateChargeEpic,
  removeChargeEpic,
  addJustAskEpic,
  updateJustAskEpic,
  getDigitalChannelsEpic,
  getWorkOrderByIdEpic,
  searchForInventoryEpic,
  transferTechEquipmentEpic,
  getUserChannelGrantEpic,
  getUserChannelGrantAppianEpic,
  sendTransactionLogEpic,
  addCloseRequestEpic,
  startOrderCloseEpic,
  sendHitEpic,
  sendBalancingHitEpic,
  sendRefreshHitEpic,
  updateTagsEpic,
  outletUpdateEpic,
  outletUpdateAppianEpic,
  addEquipmentOptionEpic,
  sendUnpairPairEpic,
  updateCustomerEmailEpic,
  unnecessaryTruckRollEpic,
  getAddressFromBillerEpic,
  getActiveServicesEpic,
  getProvisioningStatusEpic,
  getHomeVerifyEpic,
  setHomeVerifyEpic,
  pinResetEpic,
  deliveryProofEpic,
  asurionPlusEnrollmentEpic,
  getNoAccessReasonListEpic,
  addEquipmentBySerialNumberEpic,
  transferWorkOrderEpic
];

export default combineEpics(...epics);



// WEBPACK FOOTER //
// ./src/epics/index.js